import { BaseAPI } from '../../BaseApi';
import {
  convertFromIThirdPartyContactRequestArrayToIThirdPartyContactDataArray,
  IThirdPartyContactData,
  IThirdPartyContactRequest,
} from '../../../types/contacts/IThirdPartyContact';
import { UUID } from '../../../types/shared/UUID';
import { eAPITags } from '../../eAPITags';

interface CreateThirdPartyContact {
  orderId: UUID;
  body: IThirdPartyContactData;
}

interface DeleteThirdPartyContact {
  orderId: UUID;
  contactId: UUID;
}

export const ThirdPartyContactsApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listThirdPartyOrderContacts: build.query<IThirdPartyContactData[], UUID>({
      query: (orderId) => `/timber/api/internal/orders/${orderId}/third_party_contacts`,
      transformResponse: (response: IThirdPartyContactRequest[]) =>
        convertFromIThirdPartyContactRequestArrayToIThirdPartyContactDataArray(response),
      providesTags: (result, error, orderId) => [{ type: eAPITags.OrderThirdPartyContacts, id: orderId }],
    }),
    addThirdPartyContact: build.mutation<IThirdPartyContactData, CreateThirdPartyContact>({
      query: ({ orderId, body }) => ({
        url: `/timber/api/internal/orders/${orderId}/third_party_contacts`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderThirdPartyContacts, id: orderId }],
    }),
    updateThirdPartyContact: build.mutation<IThirdPartyContactData, CreateThirdPartyContact>({
      query: ({ orderId, body }) => ({
        url: `/timber/api/internal/orders/${orderId}/third_party_contacts/${body.id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderThirdPartyContacts, id: orderId }],
    }),
    deleteThirdPartyContact: build.mutation<void, DeleteThirdPartyContact>({
      query: ({ orderId, contactId }) => ({
        url: `/timber/api/internal/orders/${orderId}/third_party_contacts/${contactId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderThirdPartyContacts, id: orderId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListThirdPartyOrderContactsQuery,
  useAddThirdPartyContactMutation,
  useUpdateThirdPartyContactMutation,
  useDeleteThirdPartyContactMutation,
} = ThirdPartyContactsApi;
